import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import EmployeeDirectoryPage from "@/pages/employee/EmployeeDirectoryPage";

export const Route = createFileRoute("/employee/directory")({
  head: () => pageHead("Employee · Directory", "AKIVA employee · directory portal.", "/employee/directory", true),
  component: EmployeeDirectoryPage,
});
